<template>
  <div class="about-container">
    <div class="description-container">
      <h1>Who, Me?</h1><br>
      <p>I am a full-stack software engineer. My journey into coding began in college when I decided to give a few classes a shot—and I’ve been hooked ever since. I graduated from Weber State University with a Bachelor's degree in Computer Science and dove straight into the tech world.</p>
      <br>
      <p>Most days, you’ll find me working with Vue.js, MySQL, and Node.js, but I’ve dabbled in a little bit of everything. PHP, Ember.js, Python? Been there, done that. React.js, Angular.js, Java, C++, MongoDB & more.</p>
      <br>
      <p>Outside all my coding, I enjoy going golfing or snowboarding depending on the season, watching or playing hockey. And relaxing with some video games or a good movie.</p>
      <br>
      <p>I am passionate about technology with a focus on web development. I specialize in the MEVN, MEAN, MEEN and MERN stacks, however, I am not latched to a specific to a framework or language. In this line of work, it's about adapting, and what works best for the project. I look forward to learning any stack or language.</p>
    </div>
    <div class="images-container">
      <img src="../../assets/developer-logo.png" class="logo dev-logo"><br>
      <img src="../../assets/golf-logo.png" class="logo golf-logo">
      <img src="../../assets/snowboard-logo.png" class="logo snowboard-logo"><br>
      <img src="../../assets/utah-mammoth-logo.png" class="logo mammoth-logo">
      <img src="../../assets/WSU-logo.png" class="logo wsu-logo">
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  props: {
  }
}
</script>

<style scoped>
  .about-container {
    display: flex;
    height: 100vh;
    overflow-y: hidden;
  }
  .description-container {
    position: relative;
    top: 30%;
    left: 10%;
    max-width: 750px;
    p {
      color: rgba(255, 255, 255, 0.75);
      font-weight: 200;
      font-size: 1.4rem;
    }
  }
  h1 {
    color: #00eeff;
    font-size: 3rem;
  }
  .images-container {
    position: relative;
    left: 20%;
    top: 20%;
    .dev-logo, .snowboard-logo {
      position: relative;
      left: 55%;
    }
    .golf-logo {
      position: relative;
      left: 25%;
    }
    .wsu-logo {
      position: relative;
      left: 70%;
      top: -5%;
    }
  }
  .logo {
    max-width: 300px;
    max-height: 300px;
  }
  @media (max-device-width: 660px) {
    .images-container {
      display: none;
    }
    .about-container {
      overflow-y: auto;
    }
    .description-container {
      top: calc(65px + 2%);
      left: 0px;
      overflow-x: hidden;
      padding: 10px;
    }
  }
</style>